import React from 'react'
import config from 'config'
import useAccount from 'hooks/account/useAccount'
import lusiniFunctionsFetch from 'utils/lusiniFunctionsFetch'
import { newsletterRegistered } from './events'

export type CreateContactResponse = {
  status: 'success' | 'failure'
  mode: 'NO_MAIL_TRIGGER' | 'MAIL_TRIGGER' | 'ALREADY_OPTIN' | string
  meta: unknown
}

export default function useNewsletterRegistrationForm(props: {
  subscriptionID: string
  emailError: string
}) {
  const account = useAccount()
  const [channel, setChannel] = React.useState<'b2b' | 'b2c'>(
    account.channel || 'b2b'
  )
  const [error, setError] = React.useState<string>('')
  const [firstName, setFirstName] = React.useState('')
  const [lastName, setLastName] = React.useState('')
  const [email, setEmail] = React.useState('')
  const [acceptCondition, setAcceptCondition] = React.useState(false)
  const [acceptNewsletter, setAcceptNewsletter] = React.useState(false)
  const [completion, setCompletion] = React.useState<
    'success' | 'failure' | 'pending'
  >('pending')
  const [completionMode, setCompletionMode] = React.useState<
    'NO_MAIL_TRIGGER' | 'MAIL_TRIGGER' | 'ALREADY_OPTIN' | 'PENDING' | string
  >('PENDING')

  const onSubmit = async (e) => {
    e.preventDefault()
    setError('')

    // check if available checkboxes are checked
    const valid = email && email.match(/\S+@\S+\.\S+/)

    if (!valid) {
      setError(props.emailError)
    } else {
      try {
        const result = await lusiniFunctionsFetch<CreateContactResponse>(
          'https://functions.lusini.com/.netlify/functions/newsletter-createContactWithOptIn',
          {
            method: 'POST',
            body: JSON.stringify({
              email: email,
              location: config.locale,
              channel: channel,
              subscriptionSource: props.subscriptionID
            })
          }
        ).then((res) => res)

        if (result.status === 'success') {
          setCompletion('success')
          setCompletionMode(result.mode)
          newsletterRegistered(email, result.mode)
        }
        if (result.status === 'failure') {
          setCompletion('failure')
        }
      } catch {
        setCompletion('failure')
      }
    }
  }

  return {
    channel,
    setChannel,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    email,
    setEmail,
    acceptCondition,
    setAcceptCondition,
    acceptNewsletter,
    setAcceptNewsletter,
    completion,
    completionMode,
    onSubmit,
    error
  }
}
